import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import {
  useAuthContext,
  useCustomerContext,
  useOfflineModeContext,
} from '../context';
import { isBatEmployee } from '../utils/roles';

const FloatButton = () => {
  const history = useHistory();
  const location = useLocation();
  const { customer } = useCustomerContext();
  const { authUser } = useAuthContext();

  const { networkState } = useOfflineModeContext();
  const isOnline = networkState?.online;

  const [shouldRender, setShouldRender] = useState(false);
  const [visible, setVisible] = useState(false);

  const isVisible = customer?.id && location.pathname !== '/ocrPreview';

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      // Slight delay before fade/slide-in
      requestAnimationFrame(() => {
        setVisible(true);
      });
    } else {
      setVisible(false);
      // Wait for animation before unmount
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isVisible]);

  const handleClick = () => {
    history.push('/ocrPreview');
  };

  if (!shouldRender || !isOnline || isBatEmployee(authUser)) return null;

  return (
    <Button
      type="primary"
      shape="circle"
      icon={<CameraOutlined />}
      size="large"
      onClick={handleClick}
      style={{
        position: 'fixed',
        right: 5,
        bottom: 'calc(113px + env(safe-area-inset-bottom, 0px) + var(--product-keyboard-height, 0px))',
        zIndex: 1000,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      }}
    />
  );
};

export default FloatButton;
